import * as React from 'react'
// libs
import { motion } from 'motion/react'
// styles
import s from './styles.module.css'
// assets
import Map from '../../../../../assets/imgs/alumni/map.png'
import Alumni from '../../../../../assets/imgs/alumni/alumni.png'
import Arrow2 from '../../../../../assets/imgs/recruting/arrow-2.png'
import Matching from '../../../../../assets/imgs/alumni/matching.png'
import MailIcon from '../../../../../assets/imgs/recruting/mail-icon.png'

const float = (dx = 0, dy = 6, dur = 6) => ({
  animate: { x: [0, dx, 0, -dx, 0], y: [0, -dy, 0, dy, 0] },
  transition: {
    duration: dur,
    repeat: Infinity,
    repeatType: 'loop',
    ease: 'easeInOut',
  },
})

const OneWeekImplementation = () => {
  return (
    <div className={s.root}>
      <motion.img
        className={`${s.layer} ${s.map}`}
        src={Map}
        {...float(2, 5, 7)}
      />

      <motion.img
        className={`${s.layer} ${s.alumni}`}
        src={Alumni}
        {...float(0, 4, 8)}
      />

      <motion.img
        className={`${s.layer} ${s.matching}`}
        src={Matching}
        {...float(3, 3, 7.5)}
      />

      <motion.img
        className={`${s.layer} ${s.mail}`}
        src={MailIcon}
        animate={{ scale: [1, 1.06, 1] }}
        transition={{
          duration: 1.2,
          ease: 'easeInOut',
          repeat: Infinity,
          repeatDelay: 2,
        }}
      />

      <motion.img
        className={`${s.layer} ${s.arrow}`}
        src={Arrow2}
        animate={{ rotate: [0, 3, 0, -3, 0] }}
        transition={{ duration: 5.3, repeat: Infinity, ease: 'easeInOut' }}
        style={{ originX: 0.7, originY: 0.4 }}
      />
    </div>
  )
}

export default OneWeekImplementation
